/** The physical kind of a Seat, the same in every event */
export enum SeatType {
  STANDARD = 'standard',
  WHEELCHAIR = 'wheelchair',
  PLUS_SIZE = 'plus_size',
  REDUCED_MOBILITY = 'reduced_mobility',
}

export const SeatTypeLabels: Record<SeatType, string> = {
  [SeatType.STANDARD]: 'Comum',
  [SeatType.WHEELCHAIR]: 'Cadeira de rodas',
  [SeatType.PLUS_SIZE]: 'Pessoa obesa',
  [SeatType.REDUCED_MOBILITY]: 'Mobilidade reduzida',
}

/** Standard seats show no icon */
export const SeatTypeIcons: Record<SeatType, string | null> = {
  [SeatType.STANDARD]: null,
  [SeatType.WHEELCHAIR]: 'fa-solid fa-wheelchair',
  [SeatType.PLUS_SIZE]: 'fa-solid fa-arrows-left-right',
  [SeatType.REDUCED_MOBILITY]: 'fa-solid fa-person-cane',
}

export const SeatTypeColors: Record<SeatType, string> = {
  [SeatType.STANDARD]: '#78909c',
  [SeatType.WHEELCHAIR]: '#1e88e5',
  [SeatType.PLUS_SIZE]: '#8e24aa',
  [SeatType.REDUCED_MOBILITY]: '#00897b',
}
